module.exports = __webpack_public_path__ + "img/amount-rounded.2e20bb68.svg";